import { DefaultMessageService } from "./message/default-message.service";
import { MessageService } from "./message/message.service";
import { CommonModule } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule, Optional, SkipSelf } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { SQLiteStorageService } from "./storage/sqlite-storage.service";
import { StorageService } from "./storage/storage.service";
import { AppUtils } from "./utils/app-utils";
import { NetworkService } from './network/network.service';
import { MobileNetworkService } from './network/mobile-network.service';
import { MobileService } from './utils/mobile-event.service';
import { HttpService } from './httpclient/http-client.service';

@NgModule({
	imports: [ CommonModule, HttpClientModule, TranslateModule, RouterModule ],
	providers: [
		{
			provide: HttpClient,
			useClass: HttpService
		},
		{
			provide: StorageService,
			useClass: SQLiteStorageService
		},
		{
			provide : MessageService,
			useClass: DefaultMessageService
		},
		{
			provide: NetworkService,
			useClass: MobileNetworkService
		},
		MobileService,
		AppUtils
	]
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error(
				`${parentModule} has already been loaded. Import Core module in the AppModule only.`
			);
		}
	}
}
